import React from "react";

const defaultAspirationalDistrictData = [
  { state: "", district: "", amount: "" },
];

const AspirationalDistrictTable = ({
  aspirationalDistrictData,
  setAspirationalDistrictData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...aspirationalDistrictData];
    updated[index][field] = value;
    setAspirationalDistrictData(updated);
  };

  const addRow = () => {
    setAspirationalDistrictData([
      ...aspirationalDistrictData,
      { state: "", district: "", amount: "" },
    ]);
  };

  const removeRow = () => {
    if (aspirationalDistrictData.length > 1) {
      setAspirationalDistrictData(aspirationalDistrictData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const addButtonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  const removeButtonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={header}>S. No</th>
            <th style={header}>State</th>
            <th style={header}>Aspirational District</th>
            <th style={header}>Amount Spend (In INR)</th>
          </tr>
        </thead>
        <tbody>
          {aspirationalDistrictData.map((row, index) => (
            <tr key={index}>
              <td style={cell}>{index + 1}.</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="State"
                  value={row.state}
                  onChange={(e) => handleChange(index, "state", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="District"
                  value={row.district}
                  onChange={(e) =>
                    handleChange(index, "district", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Rs."
                  value={row.amount}
                  onChange={(e) =>
                    handleChange(index, "amount", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default AspirationalDistrictTable;
